






import { Component, Mixins, Prop } from "vue-property-decorator";

import { WidgetMixin, LayoutMixin } from "./mixins";


@Component({
  components: {
    WidgetGroup: () => import("@/components/WidgetGroup.vue")
  }
})
export default class WCol extends Mixins(WidgetMixin, LayoutMixin) {
  @Prop()
  col?: boolean

  @Prop()
  cols?: number | string

  @Prop()
  sm?: number | string

  @Prop()
  md?: number | string

  @Prop()
  lg?: number | string

  @Prop()
  xl?: number | string
}
